export default "__VITE_ASSET__BTTKOrek__"